module.exports = __webpack_public_path__ + "static/media/punecity.76d36eab.png";